module.exports = __webpack_public_path__ + "img/gd_white.1e010c27.png";